import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { getDocumentHeadProps } from '../selectors/documentHead';
import DocumentHead from '../components/DocumentHead';
import onlyIf from '../hocs/onlyIf';
var isNotLoading = function (_a) {
    var isLoading = _a.isLoading;
    return !isLoading;
};
export default compose(connect(getDocumentHeadProps), onlyIf(isNotLoading))(DocumentHead);
